import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(LanguageDetector).init({
  resources: {
    en: {
      translations: {
        "vLeader": "vLeader",
        "login.email": "Email",
        "login.password": "Password",
        "login.passwordAgain": "Password Again",
        "login.login": "Login",
        "login.createAccount": "Create Account",
        "login.forgotPassword": "Forgot Password",
        "login.version": "Version",
        "login.verifyPassword": "Verify Password",
        "login.firstName": "First Name",
        "login.lastName": "Last Name",
        "login.voicePref": "Your Voice Preference",
        "login.male": "Male",
        "login.female": "Female",
        "login.validEmail": "You must give a valid email address",
        "login.loginError": "Error Logging In",
        "login.classFinder": "Your Class Code, Professor's Name, or University's Name",
        "vleader.preparingSimulation": "Please wait while we prepare your simulation...",
        "vleader.loading": "Please Wait...",
        "vleader.coach": "Coach",
        "vleader.play": "Play",
        "vleader.professor": "Professor",
        "vleader.class": "Class",
        "vleader.school": "School",
        "vleader.code": "Code",
        "vleader.search": "Search",
        "vleader.noClassData": "Please enter your class's information",
        "vleader.noClassWarning": "We need to find your class before continuing.  You may look it up with either your professors name or the signup code they may have given you.",
        "vleader.findClass": "Find Class",
        "vleader.yourJournal": "What you entered as your plan for this play",
        "vleader.originalPlan": "Read your Original Plan",
        "vleader.yourResults": "See Your Results",
        "vleader.reflect": "Reflect on What Happened",
        "vleader.save": "Save",
        "vleader.continue": "Continue",
        "vleader.savePlay": "Save Play",
        "vleader.saveReplay": "Save and Replay",
        "vleader.cancel": "Cancel",
        "vleader.yes": "Yes",
        "vleader.no": "No",
        "vleader.pass": "PASS",
        "vleader.fail": "NOT QUITE",
        "vleader.newPassword": "You must enter a new password",
        "vleader.passwordMatch": "The passwords you entered do not match",
        "vleader.passwordChange": "Change Your Password",
        "vleader.finalScoreTooltip": "A combination of your Business Score and Commitment Score gives you your final score",
        "vleader.businessScoreTooltip": "A combination all the impact factors gives you your Business Score",
        "vleader.fiScoreTooltip": "The Financial Impact of your outcome",
        "vleader.ciScoreTooltip": "The Customer Impact of your outcome",
        "vleader.erScoreTooltip": "The Employee Retention Impact of your outcome",
        "vleader.commitmentScoreTooltip": "How commited was each member of the team.  Try getting the other members of the meeting to talk more.",
        "vleader.score": "Score",
        "vleader.rounds": "Rounds",
        "vleader.round": "Round",
        "vleader.yourScore": "Your Score",
        "vleader.businessScore": "Business Score",
        "vleader.financialImpact": "Financial Impact",
        "vleader.customerImpact": "Customer Impact",
        "vleader.employeeRetention": "Employee Retention",
        "vleader.commitmentScore": "Commitment Score",
        "vleader.successTemplate": "Looking at how you played, you were <adjective triggered by percentage> <style name>. You were <2 hardest process objectives achieved> which helped you <list of outcome objectives achieved>.<Statement about style when successful>. <Statement about connections to chart>.<Statement about learner growth from this successful experience>",
        "vleader.failureTemplate": "Looking at how you played, you were not very <style name>. You did manage to <List of 2 hardest objectives Achieved> but you <list of 3 easiest unachieved objectives>.<Statement of how to achieve style which is also the plan> <Statement about style when you fail>.<Statement about learner growth from this unsuccessful experience>. Maybe try this again using some of my advice?",
        "vleader.classicEdition": "Classic Edition",
        "vleader.labEdition": "Lab Edition",
        "vleader.standardEdition": "Standard Edition",
        "vleader.exit": "Exit",
        "vleader.logOut": "Log Out",
        "vleader.edit": "Edit",
        "vleader.download": "Download",
        "vleader.download2": "If you want a specific version of the software you can download it here",
        "vleader.windowsButton": "Download Windows Version",
        "vleader.osxButton": "Download OSX Version",
        "vleader.remove": "Remove",
        "vleader.removeWarning": "Are you sure you want to delete this?  There will be no way to get it back.",
        "vleader.downloadAuto": "Click here to download your version of vLeader",
        "vleader.noObjectives": "This play has no objectives. Plan using your best judgement.",
        "vleader.shouldViewObjectives": "You should view the objectives before committing to your plan",
        "vleader.shouldViewAllObjectives": "You have not viewed all of the objective categories yet",
        "vleader.morePlan": "You might want to write a more detailed plan.",
        "vleader.reviewLesson": "Review the Lesson",
        "vleader.businessResults": "Business Results",
        "vleader.commitmentScoring": "Commitment Scoring",
        "vleader.savePlan": "Save your Plan",
        "vleader.notEntered": "Not Entered",
        "vleader.scenario1Explore": "Module 2 Explore",
        "vleader.scenario1Assess": "Module 2 Assess",
        "vleader.scenario1": "Module 2",
        "vleader.lesson1": "Lesson 1",
        "vleader.scenario2Explore": "Module 3 Explore",
        "vleader.scenario2Assess": "Module 3 Assess",
        "vleader.scenario2": "Module 3",
        "vleader.lesson2": "Lesson 2",
        "vleader.scenario3Explore": "Module 4 Explore",
        "vleader.scenario3Assess": "Module 4 Assess",
        "vleader.scenario3": "Module 4",
        "vleader.lesson3": "Lesson 3",
        "vleader.scenario4Explore": "Scenario 4 Explore",
        "vleader.scenario4Assess": "Scenario 4 Assess",
        "vleader.scenario4": "Scenario 4",
        "vleader.lesson4": "Lesson 4",
        "vleader.scenario5Explore": "Module 5 Explore",
        "vleader.scenario5Assess": "Module 5 Assess",
        "vleader.scenario5": "Module 5",
        "vleader.lesson5": "Lesson 5",
        "vleader.howToAchieve": "How To Achieve",
        "vleader.objectivesHover": "Try Hovering Over Objectives For More Info",
        "classic.preJournalTitle": "Write a brief plan outlining how you expect things to go.",
        "classic.postJournalTitle": "Reflect on your score and the charts to understand what happened",
        "classic.scene_1_bc.failureMessage": "OK good try. It’s not easy for everyone to think about what they do in conversations because conversations are so intuitive; and really don’t worry, this is the safest place to mess up and only those who care about helping you will know. The first thing to do is realize Oli can’t actually understand what you say, he only knows you introduced an idea, or supported an idea, or you concluded an idea. The second thing to realize is that if you haven’t clicked on an element on the screen by the time he stops talking, he’ll keep on talking. So make sure as he is saying something, you click on something so you aha a chance to think about what you want to do. If you are totally confused, you might want to take the Getting Started with vLeader exercise again. if you think you just did the wrong thing, you can play again.",
        "classic.scene_1_bc.successMessage": "Great job you took an approach that caused you and Oli to discuss the right work and then end the meeting. It feels odd, I know, different from anything else you’ve ever encountered. And if it felt easy, don’t worry it gets harder as we go, these are just exercises to let you in gently to thinking about intent. Often, people wonder why they can’t type in their response. The answer is simple it’s not the response we are interested in, its your understanding of the conversational dynamics that matter most when it comes to thinking like a leader.",
        "classic.scene_1_bc.title": "Getting Work Done",
        "classic.scene_2_bc.failureMessage": "So I told you it would get harder, right? You’ve got to put Rosa at ease, make her comfortable, and to do that you need to introduce the Relaxing idea and also Encourage her. Doing that brings down her tension and as that happens you feels more comfortable telling you about her main concern. Discussing the Stressful idea simply works against you. You don’t have to wait for Rosa to speak after each time you speak, in normal conversation we might support an idea and then immediately encourage a person. So you can try that as well.",
        "classic.scene_2_bc.successMessage": "Nice work! You relaxed Rosa enough that she brought up her Main Concern and then completed it before ending the meeting. You did that partly by using a topic or idea that she found relaxing but did you notice how you had to use the personal communication option this time? So what we talk about can relax people and when we encourage people we calm them down a little. The reverse can also be true. When we criticize people they become more stressed or energized and some idea will cause people to be stressed as well.",
        "classic.scene_2_bc.title": "Getting Work Done",
        "classic.scene_4_bc.failureMessage": "Don’t worry, you can try this again. This is a bit tricky. What we are trying to do is encourage you to transact with Will. We want you to work with him on his idea so he likes you more and respects you more (you have informal influence). So when you finish collaborating with him on his need, you can use that power to introduce your need and he will likely start supporting it. Don’t be put off by him supporting you either, in the real world you might just smile and see if he’ll continue speaking. you don’t have to respond to everything that is said.",
        "classic.scene_4_bc.successMessage": "You’re doing great! I know this is work but it will pay off as you get more comfortable with thinking about intent first. As you discussed the issues with Will you were transferring different types of power. As you supported his idea you gained influence or respect and he probably liked you a bit more as well. As you built that informal power it created a changed situation where you could introduce your idea with a greater chance that he would agree to it because of your elevated informal power. This might look simplistic now but as things get more complicated, you’ll see how your choices have trade-offs that make things harder.",
        "classic.scene_4_bc.title": "Getting Commitment",
        "classic.scenario_1.initialPlay": "Scenario 1 Initial Play",
        "classic.scenario_1.explorePlay": "Scenario 1 Explore Play",
        "classic.scenario_1.assessPlay": "Scenario 1 Assess Play",
        "classic.scenario_2.initialPlay": "Scenario 2 Initial Play",
        "classic.scenario_2.explorePlay": "Scenario 2 Explore Play",
        "classic.scenario_2.assessPlay": "Scenario 2 Assess Play",
        "classic.scenario_3.initialPlay": "Scenario 3 Initial Play",
        "classic.scenario_3.explorePlay": "Scenario 3 Explore Play",
        "classic.scenario_3.assessPlay": "Scenario 3 Assess Play",
        "classic.scenario_4.initialPlay": "Scenario 4 Initial Play",
        "classic.scenario_4.explorePlay": "Scenario 4 Explore Play",
        "classic.scenario_4.assessPlay": "Scenario 4 Assess Play",
        "classic.scenario_5.initialPlay": "Scenario 5 Initial Play",
        "classic.scenario_5.explorePlay": "Scenario 5 Explore Play",
        "classic.scenario_5.assessPlay": "Scenario 5 Assess Play",
        "classic.oppurunitiesConflict": "Opportunities in Conflict",
        "classic.transformingRelationship": "Transforming Relationships",
        "unity.rounds": "Rounds",
        "unity.yourPlan": "Your Plan",
        "unity.criticize": "Criticize",
        "unity.investigate": "Investigate",
        "unity.encourage": "Encourage",
        "unity.silence": "Silence",
        "unity.oppose": "Oppose",
        "unity.support": "Support",
        "unity.conclude": "Conclude",
        "unity.dismiss": "Dismiss",
        "vleader.coaching": "Coaching",
        "vleader.labPostFeedback": "If you are satisfied with you objective score, write down what trade-offs you feel you had to make with this approach",
        "vleader.labPreFeedback": "Use objectives to form a plan"
      }
    },
    es: {
      translations: {
        "vLeader": "vLeader",
        "login.email": "Email",
        "login.password": "Password",
        "login.passwordAgain": "Password Again",
        "login.login": "Login",
        "login.createAccount": "Create Account",
        "login.forgotPassword": "Forgot Password",
        "login.version": "Version",
        "login.verifyPassword": "Verify Password",
        "login.firstName": "First Name",
        "login.lastName": "Last Name",
        "login.voicePref": "Your Voice Preference",
        "login.male": "Male",
        "login.female": "Female",
        "login.validEmail": "You must give a valid email address",
        "login.loginError": "Error Logging In",
        "login.classFinder": "Your Class Code, Professor's Name, or University's Name",
        "vleader.preparingSimulation": "Please wait while we prepare your simulation",
        "vleader.loading": "Please Wait...",
        "vleader.coach": "Coach",
        "vleader.coaching": "Coaching",
        "vleader.play": "Play",
        "vleader.professor": "Professor",
        "vleader.class": "Class",
        "vleader.school": "School",
        "vleader.code": "Code",
        "vleader.search": "Search",
        "vleader.noClassData": "Please enter your class's information",
        "vleader.noClassWarning": "We need to find your class before continueing.  You may look it up with either your professors name or the signup code they may have given you.",
        "vleader.findClass": "Find Class",
        "vleader.yourJournal": "What you entered as your plan for this play",
        "vleader.originalPlan": "Read your Original Plan",
        "vleader.yourResults": "See Your Results",
        "vleader.reflect": "Reflect on What Happened",
        "vleader.save": "Save",
        "vleader.savePlay": "Save Play",
        "vleader.continue": "Continue",
        "vleader.saveReplay": "Save and Replay",
        "vleader.cancel": "Cancel",
        "vleader.yes": "Yes",
        "vleader.no": "No",
        "vleader.pass": "PASS",
        "vleader.fail": "NOT QUITE",
        "vleader.newPassword": "You must enter a new password",
        "vleader.passwordMatch": "The passwords you entered do not match",
        "vleader.passwordChange": "Change Your Password",
        "vleader.finalScoreTooltip": "A combination of your Business Score and Commitment Score gives you your final score",
        "vleader.businessScoreTooltip": "A combination all the impact factors gives you your Business Score",
        "vleader.fiScoreTooltip": "The Financial Impact of your outcome",
        "vleader.ciScoreTooltip": "The Customer Impact of your outcome",
        "vleader.erScoreTooltip": "The Employee Retention Impact of your outcome",
        "vleader.commitmentScoreTooltip": "How commited was each member of the team.  Try getting the other members of the meeting to talk more.",
        "vleader.score": "Score",
        "vleader.rounds": "Rounds",
        "vleader.round": "Round",
        "vleader.yourScore": "Your Score",
        "vleader.businessScore": "Business Score",
        "vleader.financialImpact": "Financial Impact",
        "vleader.customerImpact": "Customer Impact",
        "vleader.employeeRetention": "Employee Retention",
        "vleader.commitmentScore": "Commitment Score",
        "vleader.successTemplate": "Looking at how you played, you were <adjective triggered by percentage> <style name>. You were <2 hardest process objectives achieved> which helped you <list of outcome objectives achieved>.<Statement about style when successful>. <Statement about connections to chart>.<Statement about learner growth from this successful experience>",
        "vleader.failureTemplate": "Looking at how you played, you were not very <style name>. You did manage to <List of 2 hardest objectives Achieved> but you <list of 3 easiest unachieved objectives>.<Statement of how to achieve style which is also the plan> <Statement about style when you fail>.<Statement about learner growth from this unsuccessful experience>. Maybe try this again using some of my advice?",
        "vleader.classicEdition": "Classic Edition",
        "vleader.labEdition": "Lab Edition",
        "vleader.standardEdition": "Standard Edition",
        "vleader.exit": "Exit",
        "vleader.edit": "Edit",
        "vleader.download": "Download",
        "vleader.download2": "If you want a specific version of the software you can download it here",
        "vleader.windowsButton": "Download Windows Version",
        "vleader.osxButton": "Download OSX Version",
        "vleader.remove": "Remove",
        "vleader.removeWarning": "Are you sure you want to delete this?  There will be no way to get it back.",
        "vleader.downloadAuto": "Click here to download your version of vLeader",
        "vleader.noObjectives": "This play has no objectives. Plan using your best judgement.",
        "vleader.shouldViewObjectives": "You should view the objectives before committing to your plan",
        "vleader.shouldViewAllObjectives": "You have not viewed all of the objective categories yet",
        "vleader.morePlan": "You might want to write a more detailed plan.",
        "vleader.reviewLesson": "Review the Lesson",
        "vleader.businessResults": "Business Results",
        "vleader.commitmentScoring": "Commitment Scoring",
        "vleader.savePlan": "Save your Plan",
        "vleader.notEntered": "Not Entered",
        "vleader.scenario1Explore": "Module 2 Explore",
        "vleader.scenario1Assess": "Module 2 Assess",
        "vleader.scenario1": "Module 2",
        "vleader.lesson1": "Lesson 1",
        "vleader.scenario2Explore": "Module 3 Explore",
        "vleader.scenario2Assess": "Module 3 Assess",
        "vleader.scenario2": "Module 3",
        "vleader.lesson2": "Lesson 2",
        "vleader.scenario3Explore": "Module 4 Explore",
        "vleader.scenario3Assess": "Module 4 Assess",
        "vleader.scenario3": "Module 4",
        "vleader.lesson3": "Lesson 3",
        "vleader.scenario4Explore": "Scenario 4 Explore",
        "vleader.scenario4Assess": "Scenario 4 Assess",
        "vleader.scenario4": "Scenario 4",
        "vleader.lesson4": "Lesson 4",
        "vleader.scenario5Explore": "Module 5 Explore",
        "vleader.scenario5Assess": "Module 5 Assess",
        "vleader.scenario5": "Module 5",
        "vleader.lesson5": "Lesson 5",
        "vleader.howToAchieve": "How To Achieve",
        "vleader.objectivesHover": "Try Hovering Over Objectives For More Info",
        "classic.preJournalTitle": "Write a brief plan outlining how you expect things to go.",
        "classic.postJournalTitle": "Reflect on your score and the charts to understand what happened",
        "classic.scene_1_bc.failureMessage": "OK good try. It’s not easy for everyone to think about what they do in conversations because conversations are so intuitive; and really don’t worry, this is the safest place to mess up and only those who care about helping you will know. The first thing to do is realize Oli can’t actually understand what you say, he only knows you introduced an idea, or supported an idea, or you concluded an idea. The second thing to realize is that if you haven’t clicked on an element on the screen by the time he stops talking, he’ll keep on talking. So make sure as he is saying something, you click on something so you aha a chance to think about what you want to do. If you are totally confused, you might want to take the Getting Started with vLeader exercise again. if you think you just did the wrong thing, you can play again.",
        "classic.scene_1_bc.successMessage": "Great job you took an approach that caused you and Oli to discuss the right work and then end the meeting. It feels odd, I know, different from anything else you’ve ever encountered. And if it felt easy, don’t worry it gets harder as we go, these are just exercises to let you in gently to thinking about intent. Often, people wonder why they can’t type in their response. The answer is simple it’s not the response we are interested in, its your understanding of the conversational dynamics that matter most when it comes to thinking like a leader.",
        "classic.scene_1_bc.title": "Getting Work Done",
        "classic.scene_2_bc.failureMessage": "So I told you it would get harder, right? You’ve got to put Rosa at ease, make her comfortable, and to do that you need to introduce the Relaxing idea and also Encourage her. Doing that brings down her tension and as that happens you feels more comfortable telling you about her main concern. Discussing the Stressful idea simply works against you. You don’t have to wait for Rosa to speak after each time you speak, in normal conversation we might support an idea and then immediately encourage a person. So you can try that as well.",
        "classic.scene_2_bc.successMessage": "Nice work! You relaxed Rosa enough that she brought up her Main Concern and then completed it before ending the meeting. You did that partly by using a topic or idea that she found relaxing but did you notice how you had to use the personal communication option this time? So what we talk about can relax people and when we encourage people we calm them down a little. The reverse can also be true. When we criticize people they become more stressed or energized and some idea will cause people to be stressed as well.",
        "classic.scene_2_bc.title": "Getting Work Done",
        "classic.scene_4_bc.failureMessage": "Don’t worry, you can try this again. This is a bit tricky. What we are trying to do is encourage you to transact with Will. We want you to work with him on his idea so he likes you more and respects you more (you have informal influence). So when you finish collaborating with him on his need, you can use that power to introduce your need and he will likely start supporting it. Don’t be put off by him supporting you either, in the real world you might just smile and see if he’ll continue speaking. you don’t have to respond to everything that is said.",
        "classic.scene_4_bc.successMessage": "You’re doing great! I know this is work but it will pay off as you get more comfortable with thinking about intent first. As you discussed the issues with Will you were transferring different types of power. As you supported his idea you gained influence or respect and he probably liked you a bit more as well. As you built that informal power it created a changed situation where you could introduce your idea with a greater chance that he would agree to it because of your elevated informal power. This might look simplistic now but as things get more complicated, you’ll see how your choices have trade-offs that make things harder.",
        "classic.scene_4_bc.title": "Getting Commitment",
        "classic.scenario_1.initialPlay": "Scenario 1 Initial Play",
        "classic.scenario_1.explorePlay": "Scenario 1 Explore Play",
        "classic.scenario_1.assessPlay": "Scenario 1 Assess Play",
        "classic.scenario_2.initialPlay": "Scenario 2 Initial Play",
        "classic.scenario_2.explorePlay": "Scenario 2 Explore Play",
        "classic.scenario_2.assessPlay": "Scenario 2 Assess Play",
        "classic.scenario_3.initialPlay": "Scenario 3 Initial Play",
        "classic.scenario_3.explorePlay": "Scenario 3 Explore Play",
        "classic.scenario_3.assessPlay": "Scenario 3 Assess Play",
        "classic.scenario_4.initialPlay": "Scenario 4 Initial Play",
        "classic.scenario_4.explorePlay": "Scenario 4 Explore Play",
        "classic.scenario_4.assessPlay": "Scenario 4 Assess Play",
        "classic.scenario_5.initialPlay": "Scenario 5 Initial Play",
        "classic.scenario_5.explorePlay": "Scenario 5 Explore Play",
        "classic.scenario_5.assessPlay": "Scenario 5 Assess Play",
        "classic.oppurunitiesConflict": "Opportunities in Conflict",
        "classic.transformingRelationship": "Transforming Relationships",
        "unity.rounds": "Rounds",
        "unity.yourPlan": "Your Plan",
        "unity.criticize": "Criticize",
        "unity.investigate": "Investigate",
        "unity.encourage": "Encourage",
        "unity.silence": "Silence",
        "unity.oppose": "Oppose",
        "unity.support": "Support",
        "unity.conclude": "Conclude",
        "unity.dismiss": "Dismiss"
      }
    }
  },
  fallbackLng: "en",
  debug: true,

  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false,

  interpolation: {
    escapeValue: false,
    formatSeparator: ","
  },

  react: {
    wait: true
  }
});

export default i18n;
